import type { UIMessage } from 'ai';
import { createContext, useContext } from 'react';

export type ChatSendInput = string | { text: string; parts?: UIMessage['parts'] };

export type ChatSendFn = (input: ChatSendInput) => void;

export const ChatSendContext = createContext<ChatSendFn | null>(null);

export function useChatSend(): ChatSendFn | null {
  return useContext(ChatSendContext);
}
